import {} from 'viem';
export function isSimulateContractRequest(tx) {
    return tx.abi !== undefined;
}
//# sourceMappingURL=simulateContract.js.map